<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <!--
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <div class="btn btn-default btn-table-title" @click="toggleModal('cr')">新增綁定</div>
        </div>
      </div>
    </div>
    -->
    <div class="row">
      <div class="col-xs-12 text-left">
        <div class="form-group" v-if="brandSelectShow">
          <select class="form-control h-38" v-model="brandSelect">
            <option v-for="brand in brandBrief" :value="brand.value">
              {{brand.label}}
            </option>
          </select>
        </div>
        <div class="form-group" v-if="storeSelectShow">
          <select class="form-control h-38" v-model="storeSelect">
            <option v-for="store in storeBrief" :value="store.value">
              {{store.label}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th>#</th>
            <th>綁定ID</th>
            <th>方式</th>
            <!--<th>對象名稱(類型)</th>-->
            <!--<th>對象角色</th>-->
            <th>啟用</th>
            <th>更新時間</th>
            <th>建立時間</th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(notify, index) in notifyList">
            <td class="sorting_1">
              <span>{{index + 1}}</span>
            </td>
            <td>{{notify.alarm_id}}</td>
            <td>{{notifyMethodName(notify.notify_method)}}</td>
            <!--<td>{{notify.target_name}} ({{targetTypeName(notify.target_type)}})</td>-->
            <!--<td>{{targetRoleName(notify.target_role)}}</td>-->
            <td>
              <span v-if="notify.toggle" class="label label-success">正常</span>
              <span v-if="!notify.toggle"  class="label label-danger">停用</span>
            </td>
            <td>{{notify.update_time}}</td>
            <td>{{notify.create_time}}</td>
            <td>
              <button class="btn btn-danger" data-toggle="modal" data-target="#delStoreModal"
                      @click="getCurrent(notify.alarm_id, notify.target_name)"
              ><i class="fa fa-trash" aria-hidden="true"></i></button>
            </td>
            <td>
              <button class="btn btn-default" @click="toggleModal('up', notify)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 text-center">
        <ul class="pagination">
          <li class="paginate_button" v-if="pageAmount > 1 && pageGroup !== 1" @click="pageGroup = pageGroup - 1">
            <a class="c-pointer"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="getNotifyBindingList(index)" v-if="pageShow(index)">
            <a class="c-pointer">{{index}}</a>
          </li>
          <li class="paginate_button" v-if="pageAmount > 1 && pageAmount / groupAmount > pageGroup" @click="pageGroup = pageGroup + 1">
            <a class="c-pointer"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="editStoreNotifyModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">門市綁定</h4>
          </div>
          <div class="modal-body">
            <div class="box-body form p-x-0">
              <div>
                <div class="input-group" v-if="!show.cr">
                  <span class="input-group-addon"><span class="text-red">＊ </span>啟用</span>
                  <select class="form-control" v-model="binding.toggleSelect">
                    <option value="1">啟用</option>
                    <option value="0">停用</option>
                  </select>
                  <br>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <!--<button type="button" class="btn btn-success" @click="notifyBinding('cr')" v-if="show.cr">新增</button>-->
            <button type="button" class="btn btn-success" @click="notifyBinding('up')" v-if="!show.cr">修改</button>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import matcherModal from '../../../elements/Modal.vue'

export default{
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      count: 10,
      notifyList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      type: 'admin',
      selectRoleType: 'admin',
      total: {},
      maxTotal: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0,
      // bindingModal
      binding: {
        brandSelect: 0,
        storeSelect: 0,
        methodSelect: 42,
        toggleSelect: 1,
        brandBrief: [],
        storeBrief: []
      },
      // del
      delOption: {
        id: 'delStoreModal',
        title: '刪除綁定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delManager'
          }
        ]
      },
      current: {
        alarm_id: 0,
        name: ''
      }
    }
  },
  methods: {
    trigger (event) {
      if (event === 'delManager') {
        this.delBinding()
      }
    },
    delBinding () {
      var self = this
      var url = '/store/' + self.storeSelect + '/notifyBinding?alarm_id=' + self.current.alarm_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getNotifyBindingList(1)
        }
      })
    },
    showSelect (type) {
      if (this.selectRoleType === 'all') return true
      else {
        if (this.selectRoleType === type) return true
        else return false
      }
    },
    getNotifyBindingList (index) {
      this.tableIndex = index
      this.notifyList = []
      var self = this
      const data = {
        page: this.tableIndex,
        count: this.count
      }
      var url = '/store/' + self.storeSelect + '/notifyBinding/list?page=' + data.page + '&size=' + data.count
      this.getDataH('get', url, data, function (response) {
        if (response.data.status === 200) {
          self.notifyList = response.data.list
          self.maxTotal = response.data.list_total
        }
      })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    isType (type) {
      if (this.selectRoleType === type) return true
      else return false
    },
    roleName (type) {
      if (type === 'admin') {
        return '系統'
      } else if (type === 'brand') {
        return '品牌'
      } else if (type === 'store') {
        return '店家'
      }
    },
    notifyMethodName (type) {
      if (type === 41) {
        return 'LineLogin'
      } else if (type === 42) {
        return 'LineNotify'
      }
    },
    targetTypeName (type) {
      if (type === 1) {
        return 'Shopper'
      } else if (type === 2) {
        return 'Manager'
      } else if (type === 3) {
        return 'POS'
      }
    },
    targetRoleName (type) {
      if (type === 1) {
        return '一般使用者'
      } else if (type === 10) {
        return '門市'
      } else if (type === 20) {
        return '經銷商'
      } else if (type === 30) {
        return '品牌'
      } else if (type === 40) {
        return '總公司'
      } else if (type === 50) {
        return 'POS廠'
      } else if (type === 99) {
        return '系統管理員'
      }
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getBrandBrief (changeStore) {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            self.binding.brandBrief.push(obj)
            if (i === 0) {
              if (changeStore && obj.value === self.brandSelect) self.getStoreBrief(self.brandSelect)
              self.brandSelect = obj.value
            }
          }
        }
      })
    },
    getStoreBrief (brandId, method) {
      this.storeBrief = []
      this.binding.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (!method) {
              self.storeBrief.push(obj)
              self.binding.storeBrief.push(obj)
            } else self.binding.storeBrief.push(obj)
            if (i === 0) {
              if (!method) self.storeSelect = obj.value
              else self.binding.storeSelect = obj.value
              if (self.brandSelect === self.binding.brandSelect) self.binding.storeSelect = self.storeSelect
            }
          }
        }
      })
    },
    toggleModal (type, notify) {
      $('#editStoreNotifyModal').modal('toggle')
      this.binding.brandSelect = ''
      this.binding.storeSelect = ''
      this.binding.toggleSelect = 1
      if (type === 'cr') {
        this.binding.brandSelect = this.brandSelect
        this.binding.storeSelect = this.storeSelect
        this.show.cr = true
      } else {
        this.binding.brandSelect = this.brandSelect
        this.binding.storeSelect = this.storeSelect
        this.binding.toggleSelect = notify.toggle
        this.current = {
          alarm_id: notify.alarm_id,
          name: notify.name
        }
        this.show.cr = false
      }
    },
    notifyBinding (type) {
      var self = this
      var url = '/store/' + this.binding.storeSelect + '/notifyBinding'
      let data
      if (type === 'cr') {
        data = {
          notify_method: this.binding.methodSelect,
          manager_id: this.getUserId
        }
      } else {
        data = {
          alarm_id: this.current.alarm_id,
          toggle: this.binding.toggleSelect
        }
      }
      let method
      if (type === 'cr') method = 'post'
      else method = 'put'
      this.getDataH(method, url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          $('#editStoreNotifyModal').modal('toggle')
          self.getNotifyBindingList(1)
        }
      })
    },
    getCurrent (alarmId, name) {
      this.current.alarm_id = alarmId
      this.current.name = name
      this.delOption.body = '確定刪除 ' + name + ' ?<br>刪除此綁定，將無法收到通知！'
    },
    getSubordinate () {
      this.brandBrief = []
      this.binding.brandBrief = []
      this.storeBrief = []
      this.binding.storeBrief = []
      var self = this
      var url = '/manager/' + this.getSelRoleType + '/' + this.getSelManagerId + '/subordinate'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          // binding.brandBrief
          var bList = response.data.subordinate.binding_brand_list
          var sList = response.data.subordinate.store_list
          if (bList) {
            for (let i = 0; i < bList.length; i++) {
              let obj = {label: bList[i].brand_name, value: bList[i].brand_id}
              self.brandBrief.push(obj)
              self.binding.brandBrief.push(obj)
              if (i === 0) {
                if (obj.value === self.brandSelect) self.getStoreBrief(self.brandSelect)
                self.brandSelect = obj.value
              }
            }
          } else if (sList) {
            for (let j = 0; j < sList.length; j++) {
              var ssList = sList[j].binding_store_list
              for (let k = 0; k < ssList.length; k++) {
                let obj = {label: ssList[k].store_name, value: ssList[k].store_id}
                self.storeBrief.push(obj)
                self.binding.storeBrief.push(obj)
                if (j === 0 && k === 0) {
                  if (obj.value === self.storeSelect) self.getNotifyBindingList(1)
                  self.storeSelect = obj.value
                }
              }
            }
          } else self.getBrandBrief(true)
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getUserId', 'getSelRoleType', 'getSelManagerId']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    },
    fixedH () {
      return this.$parent.fixedH
    },
    brandSelectShow () {
      return this.brandBrief.length > 1 && this.$route.name !== 'storeInfo'
    },
    storeSelectShow () {
      return this.brandSelect !== 0 && this.brandSelect !== '0' && this.storeBrief.length >= 1
    }
  },
  created () {
    this.fixedH()
    this.roleType = parseInt(this.getRoleType, 10)
  },
  watch: {
    brandSelect () {
      this.getStoreBrief(this.brandSelect)
    },
    storeSelect () {
      this.getNotifyBindingList(1)
    },
    'binding.brandSelect' () {
      // this.getStoreBrief(this.binding.brandSelect, 'modal')
    },
    getSelManagerId () {
      if (this.getSelRoleType && this.getSelManagerId) this.getSubordinate()
    }
    /*
    selectRoleType () {
      this.getNotifyBindingList(1)
    }
    */
  },
  beforeRouteLeave (to, from, next) {
    this.setSelManagerId('')
    next
  }
}
</script>



// WEBPACK FOOTER //
// StoreNotifyTableTemp.vue?27301628